import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import Button from '../../Parts/Button';
import ArrowDropdown from '../../Icons/ArrowDropdown';
import HelpIcon from "../../Icons/HelpIcon";
import ArrowToolTip from "../../common/ArrowToolTip";

const styles = () => ({
  entry: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  inline: {
    display: 'inline-flex',
    alignItems: 'center',
  },
});

class ExcludeKeywordSearchControl extends React.Component {
  // 複数のキーワード検索の種類があるので、それぞれに対応できるように抽象度を高めに記載しています。
  render() {
    const { classes, disabled, typeKey, tooltipText } = this.props;

    // "company"等の文字列が入り、"company_exclude_keyword"等になる
    const excludeType = typeKey + "_exclude_keyword";

    return (
      <div style={this.props.style}>
        <div className={classes.inline}>
          <Button
            icon={
              <ArrowDropdown
                color="#71737B"
                width={16}
                height={16}
                style={{
                  transform: this.props.showField
                    ? "translateX(-2px) rotate(0deg)"
                    : "translateX(-2px) rotate(-90deg)",
                }}
              />
            }
            text="除外キーワードを設定"
            type="ghost"
            size="extra-small"
            disabled={disabled}
            handleClickButton={this.props.toggleField}
            style={{
              color: disabled ? "#B1B3B9" : "#71737B",
              border: "none",
              minWidth: "unset",
              width: "unset",
              padding: "0px 5px",
            }}
          />
          {tooltipText && (
            <div>
              <ArrowToolTip
                text={tooltipText}
                tooltipMaxWidth={"200"}
              >
                <HelpIcon
                  width={12}
                  height={12}
                  color="#71737B"
                />
              </ArrowToolTip>
            </div>
          )}
        </div>

        {this.props.showField && (
          <div style={{ width: '100%' }}>
            <TextField
              id={excludeType}
              type={excludeType}
              placeholder="除外キーワードを入力"
              value={this.props.keyword}
              onChange={(e) => this.props.handleChange(e, excludeType)}
              InputProps={{
                disableUnderline: true,
              }}
              fullWidth
            />
            {this.props.children}
          </div>
        )}
      </div>
    )
  }
}

ExcludeKeywordSearchControl.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  typeKey: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  keyword: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  showField: PropTypes.bool.isRequired,
  toggleField: PropTypes.func.isRequired,
  tooltipText: PropTypes.string,
  children: PropTypes.node,
};

ExcludeKeywordSearchControl.defaultProps = {
  tooltipText: null,
}

export default withStyles(styles)(ExcludeKeywordSearchControl);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/controls/ExcludeKeywordSearchControl.jsx